export default "__VITE_ASSET__Dg2E41AG__"